import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

import { assistantPath } from '../assistant/paths';
import { Absent } from '../../../chrome/measure';
import { mt } from '../../../chrome/measure/messages';
import { Badge } from '../../../ui/badge';
import { Button } from '../../../ui/button';
import type { Digest } from '../api/schemas';
import { dayMonth } from './format';
import { pub, pubPlural } from './messages';

export function DigestBody(props: {
  digest: Digest;
  campaignId: string;
  postId: string;
}): ReactNode {
  const { digest, campaignId, postId } = props;
  if (digest.text === null) return <Absent reason={{ text: pub('digest.none') }} />;

  return (
    <>
      <p className="text-body">{digest.text}</p>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap gap-2">
          {/* Generated from comments the organisation actually collected, never
              from an inferred population, so its fidelity is fixed rather than
              read off a field the wire has no room for yet. */}
          <Badge variant="secondary">{mt('fidelity.MEASURED')}</Badge>
          {digest.comments_read !== null && (
            <Badge variant="secondary">
              {pubPlural('digest.read.other', digest.comments_read, {
                count: digest.comments_read,
              })}
            </Badge>
          )}
          {digest.window !== null && (
            <Badge variant="secondary">
              {pub('digest.window', {
                from: dayMonth(digest.window[0]),
                to: dayMonth(digest.window[1]),
              })}
            </Badge>
          )}
        </div>
        <Button asChild variant="link" size="sm" className="px-0">
          <Link to={assistantPath(campaignId, postId)}>{pub('digest.ask')}</Link>
        </Button>
      </div>
    </>
  );
}
